module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("Geographic Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.region),
      expression: "salesdata.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.fiteredResult($event, 'region')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "id": "region"
      },
      domProps: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.site),
      expression: "salesdata.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "site"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.fiteredResult($event, 'site')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.site_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "id": "site"
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.siteName))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("On")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": function($event) {
        _vm.fiteredResult($event, 'startDate')
      }
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "margin-top": "23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'salesdataCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn addbtn"
  }, [_vm._v("Add New")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-server-table', {
    ref: "salesdataTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d924d6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d924d6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Salesdata/salesdata.vue
// module id = 2358
// module chunks = 0